import React, { useState } from 'react';
import classnames from 'classnames';
import { Button } from 'components/form/Button/Button';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { ReactComponent as BlueChevronDown } from 'style/_assets/icons/blue-chevron-down.svg';

import './SingleSelectDropdown.scss';

const SingleSelectDropdown = props => {
  const { className, initialText, onSortBy, options, module, prefix } = props;

  const [isOpenFilterButton, setOpenFilterButton] = useState(false);

  const handleOpenFilterButton = () => {
    setOpenFilterButton(!isOpenFilterButton);
  };

  const handleItemClick = item => {
    onSortBy(item, module);
    setOpenFilterButton(false);
  };

  return (
    <FlexContainer
      className={classnames(className, 'singleselectdropdown-container block')}
    >
      <Button onClick={handleOpenFilterButton} neverFullWidth tab-index="0">
        <div className="singleselectdropdown-button-view">
          {prefix}
          {initialText}
          <span className="margL8">
            <BlueChevronDown
              role="img"
              className="dropdown-icon"
              aria-label={'BlueChevronDown'}
            />
          </span>
        </div>
      </Button>
      {isOpenFilterButton && (
        <div className="singleselectdropdown-body-container bgWhite margT4 padTB8 borderRad8 m-margR16">
          <FlexContainer row>
            {options.map(item => {
              return (
                <Label
                  className="dropdown-item text-14 fontGray400 padTB12 padLR16 width100"
                  onClick={() => handleItemClick(item)}
                >
                  {item}
                </Label>
              );
            })}
          </FlexContainer>
        </div>
      )}
    </FlexContainer>
  );
};

export default SingleSelectDropdown;
